import { render } from "./ProgramAssignTracks.vue?vue&type=template&id=f51259b8&scoped=true&ts=true"
import script from "./ProgramAssignTracks.vue?vue&type=script&lang=ts"
export * from "./ProgramAssignTracks.vue?vue&type=script&lang=ts"

import "./ProgramAssignTracks.vue?vue&type=style&index=0&id=f51259b8&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f51259b8"]])

export default __exports__